import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimmer, Modal } from "semantic-ui-react";
import { closeModal, openModal } from "../../redux/Modals/ModalActions";
import useTheme from "../../hooks/useTheme";
import { AppColumn } from "../UI/Layouts";
import { useResponsive } from "../UI/ResponsiveContext";
import { SizedBox } from "../UI/Sizes";
import { AppContainer } from "../UI/Container";

const AppModal = ({ children, closeModal, width, padding, popup = false }) => {
    const { isMobile } = useResponsive();
    const theme = useTheme();

    const newHeight = popup ? (isMobile ? '60%' : '60%') : (isMobile && "100%");
    const newWidth = popup ? (isMobile ? '90%' : '48%') : (width ?? (isMobile ? "100%" : "70%"));


    return (
        <Modal
            basic
            centered={true}
            open={true}
            closeOnEscape={true}
            closeOnDimmerClick={!popup}
            onClose={() => {
                closeModal();
            }}
            style={{
                margin: "0",
                padding: "0",
                top: "0",
                borderRadius: popup ? theme.radius.default : (isMobile ? "0px" : theme.radius.default),
                minHeight: '200px',
                maxHeight: newHeight,
                width: newWidth,
                marginTop: popup ? theme.spacing.contentElementPadding : (isMobile ? "0px" : theme.spacing.contentPadding),
                marginBottom: isMobile ? "0px" : theme.spacing.contentPaddingBig,
                backgroundColor: theme.colors.white,
                transform: "none",
            }}
        >
            <AppColumn
                mainAxisAlignment={"center"}
                style={{
                    backgroundColor: theme.colors.white,
                    borderRadius: popup ? theme.radius.default : (isMobile ? "0px" : theme.radius.default),

                }}
                crossAxisAlignment={"stretch"}
            >
                <AppColumn>
                    {padding ? (<div style={{
                        padding: padding
                    }}>
                        {children}

                    </div>) : <AppContainer>
                        <SizedBox height={theme.spacing.contentElementPadding} />
                        {children}
                    </AppContainer>}
                </AppColumn>
            </AppColumn>
        </Modal>
    );
}




const actions = {
    closeModal,
    openModal,
};


export default connect(null, actions)(AppModal);
export const APP_MODAL = "AppModal";
